<template lang="html">

  <div class="finca-view la-bodega">

    <section class="banner-intro brown animation full-view-intro column-center" data="la-bodega">

      <h1 class="title -intro">{{$t('vistas.la_bodega')}}</h1>

      <h2 class="subtitle-intro">{{$t('vistas.la_finca')}}</h2>

      <a class="enlace-intro" style="padding-top: 10px; text-align: center;" :href="$t('enlaces.mejor_bodega_CM')" target="_blank">
        <u style="font-weight: 500;">{{ $t('mejor_bodega_CM') }}</u>
      </a>
    </section>


    <section class="new-texto-imagen row-center ais animation">

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.la_bodega.cuadro_uno.titulo')}}</h2>
        <p v-html="$t('la_tierra.la_bodega.cuadro_uno.texto')"></p>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/la-bodega/background-instalaciones.jpg" alt="">
      </div>

    </section>

    
    <section class="new-texto-imagen -inverse row-center ais animation">

      <div class="contenedor-imagen">
        <img src="/static/img/la-bodega/background-la-bodega.jpg" alt="">
      </div>

      <div class="textos column-center">
        <h2 class="title">{{$t('la_tierra.la_bodega.cuadro_dos.titulo')}}</h2>
        <div v-html="$t('la_tierra.la_bodega.cuadro_dos.texto')"></div>
       
      </div>

    </section>

    


    <section class="animation imagen-full-texto row-start" data="proceso-del-vino" :id="$t(`slider_proceso.proceso_vino.id`)">

      <div class="contenedor-texto column-start">

        <h2 class="title">{{$t('la_tierra.la_bodega.proceso.titulo')}}</h2>
        <p>{{$t('la_tierra.la_bodega.proceso.cuerpo')}}</p>
        <router-link :to="$t('enlaces.proceso_vino')" class="btn -proceso">
          <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
        </router-link>

      </div>

      <div class="enlace-proceso">

        <router-link :to="$t('enlaces.proceso_vino')" class="btn-container">

          <span class="btn">
            <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
          </span>

        </router-link>

      </div>

    </section>

    <section class="animation imagen-full-texto row-start" data="proceso-del-cava" :id="$t(`slider_proceso.proceso_cava.id`)">

      <div class="contenedor-texto column-start">

        <h2 class="title">{{$t('la_tierra.la_bodega.proceso_cava.titulo')}}</h2>
        <p>{{$t('la_tierra.la_bodega.proceso_cava.cuerpo')}}</p>
        <router-link :to="$t('enlaces.proceso_cava')" class="btn -proceso">
          <span>{{$t('la_tierra.descubrir_proceso')}}</span>
        </router-link>
      </div>

      <div class="enlace-proceso">

        <router-link :to="$t('enlaces.proceso_cava')" class="btn-container">

          <span class="btn">
            <span>{{$t('la_tierra.descubrir_proceso')}}</span> 
          </span>

        </router-link>

      </div>

    </section>

    <section class="middle-texto-imagen row-center ais animation -tour-bodega">

      <div class="texto column-center">

        <div class="container -half">

          <h2 class="title">{{$t('la_tierra.la_bodega.sala_barricas.titulo')}}</h2>

          <p>{{$t('la_tierra.la_bodega.sala_barricas.cuerpo')}}
            <a class="enlace-bodega" :href="$t('enlaces.mejor_bodega_CM')" target="_blank">
              <u style="font-weight: 500;">{{ $t('mejor_bodega_CM') + "." }}</u>
            </a>
          </p>

          <router-link :to="$t('enlaces.enoturismo')" class="btn -pc">
            <span>{{$t('la_tierra.la_bodega.sala_barricas.boton_large')}}</span>
          </router-link>

          <router-link :to="$t('enlaces.enoturismo')" class="btn -movil">
            <span>{{$t('la_tierra.la_bodega.sala_barricas.boton_short')}}</span>
          </router-link>

        </div>
        <img src="/static/img/tripadvisor-blanco.png" alt="Logo Tripadvisor" class="logo-tripadvisor" />

      </div>

      <tour-bodega></tour-bodega>
      


    </section>

    <donde-estamos></donde-estamos>

    <otros-lugares></otros-lugares>

        <productos-banner></productos-banner>

    
  </div>

</template>

<script lang="js">


  import otrosLugares from '@/components/parts/otros-lugares';

  import dondeEstamos from '@/components/parts/donde-estamos';

  import productosBanner from '@/components/parts/productos-banner'

  import tourbodega from '@/components/views/experiencias/tour-bodega'

  export default  {
    name: 'la-bodega',
    components : {
      'otros-lugares' : otrosLugares,
      'donde-estamos' : dondeEstamos,
      'productos-banner': productosBanner,
      'tour-bodega' : tourbodega
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .full-view-intro{
    background: url("/static/img/la-bodega/background-intro.jpg") center/cover no-repeat;
  }

  .imagen-full-texto[data="proceso-del-vino"]{
    background: url("/static/img/la-bodega/proceso-del-vino.jpg") center/cover no-repeat;
  }

  .imagen-full-texto[data="proceso-del-vino"]{
    background: url("/static/img/la-bodega/proceso-del-vino.jpg") center/cover no-repeat;
  }


  .imagen-full-texto[data="proceso-del-cava"]{
    background: url("/static/img/la-bodega/proceso-del-cava.jpg") center/cover no-repeat;
  }


  .-tour-bodega .contenedor-imagen{
   background: url('/static/img/foto-tour-bodega.jpg') center no-repeat;
   min-height: 50vw;
   transition: 1s;
 }

 .-movil{
  display: none;
}


@media screen and (max-width: 1200px){
  .imagen-texto{
    padding-bottom: 100px;
    padding-top: 320px;
  }
}

@media screen and (max-width: 1100px){
  .imagen-texto{
    padding-top: 100px;
    padding-bottom: 50px;
    min-height: 0;
    .textos{
      width: 50%;
      padding-left: 20px;
    }
  }
}

@media screen and (max-width: 1023px){
  .imagen-texto{
    padding-top: 240px;
    padding-bottom: 50px;
    min-height: 0;
    .textos{
      width: 100%;
      padding-left: 0px;
    }
  }

  .imagen-full-texto{
    z-index: 4;
  }
}

@media screen and (max-width: 480px){
  .btn.-pc{
    display: none;
  }

  .btn.-movil{
    display: inline-block;
  }

   .-tour-bodega .contenedor-imagen{
   min-height: 100vw;
 }
}

</style>



// WEBPACK FOOTER //
// src/components/views/la-bodega/la-bodega.vue